import React from 'react';

import styles from './InputError.module.scss';

const InputError = ({ text = '', className = '', style = {} }) => (
  <div className={`${styles.root} ${className}`} style={style}>
    {text}
  </div>
);

export default InputError;
